(function () {
  'use strict';
  if (window.DaLucaAddonUniformityV362) return;
  window.DaLucaAddonUniformityV362 = true;

  function springBarPlaceholder() {
    var wrap = document.createElement('div');
    wrap.className = 'daluca-addon-placeholder-v362';
    wrap.setAttribute('aria-hidden','true');
    window.DaLucaI18n.setHtml(wrap, '<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="#223a56" stroke-width="2" stroke-linecap="round"><path d="M11 23h42"/><path d="M15 19v8M49 19v8"/><path d="M11 41h42"/><path d="M15 37v8M49 37v8"/></g><g fill="#d9dee2"><rect x="19" y="20" width="26" height="6" rx="3"/><rect x="19" y="38" width="26" height="6" rx="3"/></g></svg>');
    return wrap;
  }

  function normalizeCustomCards() {
    var holder = document.querySelector('.daluca-custom-builder-live--consolidated .daluca-care-inline-v35__items');
    if (!holder) return;

    Array.from(holder.children).forEach(function(card) {
      if (!card.classList.contains('daluca-care-proxy-v35')) return;
      if (!card.classList.contains('daluca-addon-card-unified-v362')) card.classList.add('daluca-addon-card-unified-v362');

      var key = String(card.dataset.dalucaCareProxy || card.dataset.dalucaStrapAddonCard || '').toLowerCase();
      var content = card.querySelector('.daluca-care-proxy-v35__content');
      var title = content && content.querySelector('strong');

      if (key === 'spring-bars') {
        if (title && window.DaLucaI18n.sourceText(title) !== 'Extra Spring Bars') window.DaLucaI18n.setText(title, 'Extra Spring Bars');
        var reason = content && content.querySelector('small');
        if (reason && window.DaLucaI18n.sourceText(reason) !== 'One extra standard pair for future strap changes.') window.DaLucaI18n.setText(reason, 'One extra standard pair for future strap changes.');
        if (!card.querySelector('.daluca-care-proxy-v35__media, .daluca-strap-addon-card-v360__media, .daluca-addon-placeholder-v362')) {
          card.insertBefore(springBarPlaceholder(), card.firstChild);
        }
      }
    });
  }

  function run() { normalizeCustomCards(); }
  var timer = 0;
  function queue() { clearTimeout(timer); timer = setTimeout(run, 40); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once:true });
  else run();

  if (document.body) new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});
  [120,350,800,1500,2600].forEach(function(ms){ setTimeout(run,ms); });
})();

